import { useEffect, useMemo, useState } from "react";

// Elenchi lunghi: si mostra una pagina alla volta per non appesantire il browser.
export function usePager(rows, size = 50) {
  const [page, setPage] = useState(1);
  const total = rows.length;
  const pages = Math.max(1, Math.ceil(total / size));
  useEffect(() => { setPage(current => (current > pages ? 1 : current)); }, [pages]);
  const visible = useMemo(() => (total <= size ? rows : rows.slice((page - 1) * size, page * size)), [rows, page, size, total]);
  return { page, pages, size, total, visible, setPage, from: total ? (page - 1) * size + 1 : 0, to: Math.min(page * size, total) };
}
